import React from "react"
import { Modal, Form, Input, Select, message } from "antd"
import lodash from "lodash"
import PropTypes from 'prop-types'

import { renderLoading } from "@/utils"
import { AdminService } from "@/services"

const { Option } = Select

class GroupComponentAddModal extends React.PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      ready: false,
      componentList: [],
      formData: {
        packageId: null,
        componentId: null
      }
    }
  }

  componentDidMount() {

    // TODO 加载所有的组件（包含代码包）信息
    this.refreshComponentList()
  }

  async refreshComponentList() {
    const params = {
      page: 1,
      page_size: 5000
    }
    const response = await AdminService.get_public_component_list(params)

    const { status, body } = response.data

    if (status <= 0) {
      return message.error("获取代码包数据失败")
    }

    this.setState({
      ready: true,
      componentList: body.components
    })
  }

  onCancel() {
    this.props.onCancel()
  }

  onSubmit() {
    const { formData } = this.state

    // 表单数据校验
    if (!formData.packageId) {
      return message.warn("请选择代码包")
    }

    if (!formData.componentId) {
      return message.warn("请选择组件")
    }

    this.props.onSubmit(formData)
  }

  updateFormData(inputData) {
    const { formData } = this.state

    const newFormData = {
      ...formData,
      ...inputData
    }
    this.setState({
      formData: newFormData
    })
  }

  getCurrentPackageComponents() {

    const { formData } = this.state
    if (!formData.packageId) return null

    const { componentList } = this.state

    const packageComponents = lodash.filter(componentList, (comp) => comp.packageId === formData.packageId)

    // 本地测试数据
    return packageComponents
  }

  collectPackageList() {
    const { componentList } = this.state
    const packagesMap = {}
    componentList.forEach((component) => {
      const { packageId, packageName, packageKey } = component
      if (packagesMap[packageId]) return

      packagesMap[packageId] = {
        id: packageId,
        name: packageName,
        key: packageKey
      }
    })

    const packageList = lodash.sortBy(Object.values(packagesMap), ["id"])

    return packageList
  }

  renderComponentSelectFormItem() {

    const packageComponents = this.getCurrentPackageComponents()
    if (!packageComponents) return null

    const { existComponentIds } = this.props
    const { formData } = this.state

    return (
      <Form.Item label="选择组件">
        <Select
          value={formData.componentId}
          placeholder="请选择组件"
          onChange={(value) => this.updateFormData({ componentId: value })}
          optionFilterProp="children"
          showSearch
        >
          {packageComponents.map((component) => {

            const isExist = existComponentIds.has(component.id)

            let label = `【${component.key}】${component.name}`
            if (isExist) {
              label += " (已存在)"
            }

            return (
              <Option value={component.id} disabled={isExist} key={component.id}>{label}</Option>
            )
          })}
        </Select>
      </Form.Item>
    )
  }

  renderForm() {

    const { ready, formData } = this.state
    if (!ready) return renderLoading()

    const packageList = this.collectPackageList()

    return (
      <Form layout="vertical">
        <Form.Item label="选择代码包">
          <Select
            value={formData.packageId}
            placeholder="请选择代码包"
            onChange={(value) => this.updateFormData({ packageId: value })}
            optionFilterProp="children"
            showSearch
          >
            {packageList.map((packge) => {
              return (
                <Option value={packge.id} key={packge.id}>{packge.name}</Option>
              )
            })}
          </Select>
        </Form.Item>

        {this.renderComponentSelectFormItem()}
      </Form>
    )
  }

  render() {

    const { title } = this.props

    return (
      <Modal
        title={title}
        visible={true}
        maskClosable={false}
        keyboard={false}
        width={500}
        okText='保存'
        cancelText='取消'
        onOk={() => this.onSubmit()}
        onCancel={() => this.onCancel()}
      >
        {this.renderForm()}
      </Modal>
    )
  }
}

GroupComponentAddModal.propTypes = {
  title: PropTypes.string,
  formData: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  existComponentIds: PropTypes.object
}

export default GroupComponentAddModal
